// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeCreateForms-StyledPersonForm_cls1__9OYMQ","cls2":"PayeeCreateForms-StyledPersonForm_cls2__b85PF PayeeCreateForms-StyledPersonForm_cls1__9OYMQ"};